/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryOptions } from 'src/store/fetch-services';
import { PositionReportEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  PositionReportProps,
  PositionReportViewModelBase,
} from 'src/store/generated/position-report-record.generated';

export class PositionReportViewModel extends PositionReportViewModelBase {
  constructor(props: PositionReportProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class PositionReportViewModelService {
  constructor(
    private readonly _positionReportEntityFetchService: PositionReportEntityFetchService,
  ) {}

  public getById(
    id: string,
    options?: QueryOptions,
  ): Observable<PositionReportViewModel | undefined> {
    return this._positionReportEntityFetchService.getById(id, options).pipe(
      map((positionReport) => {
        if (positionReport == null) {
          return undefined;
        }
        return new PositionReportViewModel(positionReport);
      }),
    );
  }
}
